import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-work-devex-app",
  templateUrl: "./work-devex-app.component.html",
  styleUrls: ["./work-devex-app.component.scss"],
})
export class WorkDevexAppComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/work-devex-app/work-devex-app.component.ts